/* function to delete a document from firstore */

export default function EditItem(props) {
  return (
    <button
      type="button"
      id="btnEdit"
      class="btn btn-primary btn-md center-block"
      Style="width: 100px;"
      onClick={
        () => props.handleEdit(true, props.idd)
        //console.log("idd: ", props.idd)
      }
    >
      Edit
    </button>
  );
}
